module.exports = __webpack_public_path__ + "img/imgs-item-3.77109f5c.png";